import { useState } from "react";
import images from "../../utilities/images/images";
import "./PracticeSetInstructionPage.css";

const PracticeSetModeModal = ({
  isOpen,
  setTitle = "Practice Set",
  onClose,
  onConfirm,
}) => {
  // Off by default — streak UI only after user turns it on
  const [gamificationOn, setGamificationOn] = useState(false);

  if (!isOpen) return null;

  const handleSelectTestMode = () => {
    onConfirm?.({
      selectedMode: "test",
      gamificationOn: false,
    });
  };

  const handleSelectPracticeMode = () => {
    onConfirm?.({
      selectedMode: "practice",
      gamificationOn,
    });
  };

  return (
    <div
      className="ps-mode-overlay"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="ps-mode-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ps-mode-title"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="ps-mode-close"
          onClick={onClose}
          aria-label="Close"
        >
          ✕
        </button>

        <div className="ps-mode-panel__inner">
          <div className="ps-mode-panel__heading">
            <h2 id="ps-mode-title">{setTitle}</h2>
            <p>Choose Your Practice Mode</p>
          </div>

          <div className="ps-mode-toggle-card">
            <div className="ps-mode-toggle-card__top">
              <div className="ps-mode-toggle-card__title">
                <img src={images.streakfire_icon} alt="" />
                <span>Gamification Mode</span>
              </div>
              <label className="ps-mode-switch">
                <input
                  type="checkbox"
                  checked={gamificationOn}
                  onChange={() => setGamificationOn((prev) => !prev)}
                />
                <span className="ps-mode-switch__slider" />
              </label>
            </div>
            <p className="ps-mode-toggle-card__desc">
              Enable gamification & streaks with instant feedback.
            </p>
          </div>

          <div className="ps-mode-options">
            <button
              type="button"
              className="ps-mode-option"
              onClick={handleSelectTestMode}
            >
              <div className="ps-mode-option__icon ps-mode-option__icon--test">
                <img src={images.streaktest} alt="" />
              </div>
              <div className="ps-mode-option__text">
                <h3>Test Mode</h3>
                <p>Timed test simulation(3 hours) with final results</p>
              </div>
            </button>

            <button
              type="button"
              className={`ps-mode-option ps-mode-option--practice${
                gamificationOn ? " is-streak" : ""
              }`}
              onClick={handleSelectPracticeMode}
            >
              {/* Always mounted to keep modal height stable */}
              <span
                className={`ps-mode-streak-badge${
                  gamificationOn ? " is-visible" : ""
                }`}
                aria-hidden={!gamificationOn}
              >
                <img src={images.streakfire_icon} alt="" />
                Streak Mode Activated
              </span>
              <div className="ps-mode-option__icon ps-mode-option__icon--practice">
                <img src={images.streakpractice} alt="" />
              </div>
              <div className="ps-mode-option__text">
                <h3>Practice Mode</h3>
                <p>Untimed practice with solutions & explanations</p>
                <span
                  className={`ps-mode-feedback${
                    gamificationOn ? " is-visible" : ""
                  }`}
                  aria-hidden={!gamificationOn}
                >
                  <img src={images.streaktick} alt="" />
                  Immediate feedback
                </span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PracticeSetModeModal;
